import axios from "axios";

const UpdatePackageApi = (
  packageId,
  packageTitle,
  destination,
  category,
  packageDetail1,
  packageDetail2,
  packageDetail3,
  packageDetail4,
  bookingPeriod,
  stayPeriod,
  inclusion,
  startingPrice,
  imagelinklist,
  resorts,
  roomType,
  itinerary,
  flight,
  star,
  activity,
  transferVal
) => {
  return axios.patch(
    "https://backend.planmyleisure.com/package/update-package",
    {
      packageId,
      packageTitle,
      category,
      packageDetail1,
      packageDetail2,
      packageDetail3,
      packageDetail4,
      bookingPeriod: {
        start: bookingPeriod.start,
        end: bookingPeriod.end,
      },
      stayPeriod: [stayPeriod.start, stayPeriod.end],
      inclusion,
      startingPrice,
      image: imagelinklist,
      resorts: { values: resorts },
      roomType,
      itinerary,
      flightDetails: { details: flight },
      destination,
      star: parseInt(star),
      activity: activity,
      transferVal,
    }
  );
};

export default UpdatePackageApi;
